export default function ProductInfo({ product }) {
    return (
      <div className="grid md:grid-cols-2 mb-6 gap-4">
        <div className="flex justify-center">
          <img
            src={product.images?.[0]}
            alt={product.title}
            className="w-48 h-48 md:object-cover object-contain rounded-xl shadow-md"
          />
        </div>
  
        <div className="text-center md:text-start">
          <p className="mt-1 text-sm text-stone-400">
            ترکیب قهوه
          </p>
  
          <div className="flex justify-center md:justify-start gap-2 flex-wrap mt-2">
            <span className="text-sm text-amber-800">
              {product.origin}
            </span>
          </div>
  
          <div className="mt-5">
            <p className="text-xs text-stone-400 mb-2">
              نت‌های طعمی
            </p>
  
            <div className="flex justify-center md:justify-start flex-wrap gap-2">
              {product.flavorNotes.map((note) => (
                <span
                  key={note}
                  className="px-3 py-1 rounded-full bg-amber-50 text-amber-800 text-xs font-medium"
                >
                  {note}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }